module.exports = __webpack_public_path__ + "img/vertical_7_6_0.25565a93.png";